import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import axios from "axios";
import BtnLoader from "Components/Common/Loader/BtnLoader";
import Swal from "sweetalert2";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const ConfirmDeleteModal = ({ visible, onClose, target, fetchGangTargets }) => {
  const [isLoading, setIsLoading] = useState(false);

  const deleteGangTarget = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/gang-targets/delete/${target?._id}`,
      headers: {},
      data: "",
    };

    setIsLoading(true);
    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        fetchGangTargets();
        onClose();
        Swal.fire({
          icon: "success",
          title: "Deletion Successful",
          text: "Gang Target deleted successfully",
          timer: 2000,
          showConfirmButton: true,
        });
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        onClose();
        Swal.fire({
          icon: "error",
          title: "Recharge Failed",
          text: error.response?.data?.message || "Something went wrong",
        });
      });
  };

  return (
    <Modal
      open={visible}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <div className="mr-2 text-2xl font-bold">Delete Gang Target</div>
          </div>
          <p className="mb-6 tracking-wide">
            Do you really want to delete this Target?
          </p>
          <div className="flex justify-end space-x-4 tracking-wide">
            <button
              className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
              onClick={onClose}
            >
              Cancel
            </button>

            {isLoading ? (
              <button className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]">
                <BtnLoader />
              </button>
            ) : (
              <button
                onClick={deleteGangTarget}
                className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]"
              >
                Yes, Delete
              </button>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteModal;
